import { Injectable } from '@angular/core';
import {Http, Headers} from '@angular/http';
import {Service} from "../shared/services/service";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';
import {Router} from "@angular/router";
import {TranslateService} from '@ngx-translate/core';
import {Funcoes} from "../funcoes";

declare let $:any;

@Injectable()
export class ValidarService extends Service{

  protected url: string = this.dominio + '/pub/validar/';
  public userInfo: any = {};
  protected logado = false;

  constructor(
    private router: Router,
    protected http: Http,
    private translate: TranslateService,
    protected func: Funcoes
  ){
    super();
    this.logado = !!localStorage.getItem('token');
  }

  validar(cod) {

    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    return this.http
      .get(
        this.url + cod,
        { headers }
      )
      .map(res => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/validar/validar.service.ts